import React from 'react';

import styles from './TrainSHomeFilterSection.module.scss';

interface ITrainSHomeFilterSectionProps {
  label: string;
  children: string | JSX.Element;
  onClick?: () => void;
}

const TrainSHomeFilterSection: React.FC<ITrainSHomeFilterSectionProps> = ({ label, children, onClick }) => {
  return (
    <button className={styles.container} onClick={onClick}>
      <div className={styles.label}>{label}</div>
      <div className={styles.contents}>{children}</div>
    </button>
  );
};

export default TrainSHomeFilterSection;
